import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DischargeSummaryNewComponent} from './discharge-summary-new.component';

const routes: Routes = [
  {
    path: '', component: DischargeSummaryNewComponent
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge-summary-new/discharge-summary-new.routing.ts